import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./BulkUploadInfoModal.css";

const BulkUploadInfoModal = ({ showModal, onClose, onAlpha2Click, onUpload, sampleFileUrl }) => {
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (showModal) setVisible(true);
  }, [showModal]);

  const handleCloseWithTransition = (callback) => {
    setVisible(false);
    setTimeout(() => {
      callback && callback();
    }, 300);
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
  const file = e.target.files[0];

  if (!file) return;

  const allowedTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];

  const fileExtension = file.name.split(".").pop().toLowerCase();

  if (
    !allowedTypes.includes(file.type) &&
    fileExtension !== "xlsx" &&
    fileExtension !== "xls"
  ) {
    setError("Only Excel files (.xlsx, .xls) are allowed.");
    e.target.value = null;
    return;
  }

  setError("");

  console.log("Valid Excel file selected:", file);

  // Upload file
  if (onUpload) {
    onUpload(file);
  }

  // Close popup after successful upload
  handleCloseWithTransition(onClose);

  e.target.value = null;
};


  if (!showModal && !visible) return null;

  return (
    <div className="bu-modal-overlay">
      <div className={`bu-modal ${visible ? "open" : "close"}`}>
        <div className="bu-header">
          <h2>{t("bulkUpload")}</h2>
        </div>

        <div className="bu-body">
          <p className="bu-intro">{t("PleaseFollowTheseRules")}</p>

          <ul className="bu-rules">
            <li>
              {t("UseTheServiceIDFromTheManageServiceModuleAndPasteInTheExcelsheet")}.
            </li>
            <li>
              {t("AddMultipleServiceID'sBySeparatingCommas")} (,).
            </li>
            {sampleFileUrl && (
              <li className="bu-inline-cta">
                {t("ClickHereToDownloadaEampleExcelFormat")}:
                <button
                  className="bu-chip"
                  onClick={() => window.open(sampleFileUrl, "_blank")}
                  aria-label="Download sample excel"
                >
                  {t("DownloadSample")}
                </button>
              </li>
            )}
            <li className="bu-inline-cta">
              {t("IfYouNeedAlpha2CountryCodes,ClickHere")}:
              <button
                className="bu-chip"
                onClick={() => handleCloseWithTransition(onAlpha2Click)}
                aria-label="Open Alpha 2 code reference"
              >
                {t("Alpha2Code")}
              </button>
            </li>
          </ul>

          {error && <p className="bu-error">{error}</p>}
        </div>

        <div className="bu-footer">
          <button
            className="bu-btn bu-btn-secondary"
            onClick={() => handleCloseWithTransition(onClose)}
          >
            {t("Close")}
          </button>

          <button className="bu-btn bu-btn-primary" onClick={handleUploadClick}>
            {t("UploadExcel")}
          </button>

          <input
            type="file"
            ref={fileInputRef}
            className="bu-file-input"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
          />
        </div>
      </div>
    </div>
  );
};

export default BulkUploadInfoModal;
